import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CRUDTableModule } from './crud-table';

@NgModule({
  declarations: [
    ConfirmationModalComponent,
  ],
  exports: [
    ConfirmationModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    NgbModalModule,
    NgSelectModule,
    CRUDTableModule,
  ],
  providers: [],
})
export class SharedModule { }
